// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { flare as _flare } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the flare chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 14
 * Chain Name: Flare Mainnet
 * Default Block Explorer: https://flare-explorer.flare.network
 * Default RPC URL: https://flare-api.flare.network/ext/C/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { flare } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: flare,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const flare = createCommon({
	..._flare,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
